import { getGlobalScope } from '@amplitude/analytics-core';
import dom from '@amplitude/rrweb-utils';
// These functions are not exposed in rrweb package, so we will define it here to use
// Ignoring this function since this is copied from rrweb
/* istanbul ignore next */
export function getWindowScroll(win) {
    var _a, _b, _c, _d;
    var doc = win.document;
    return {
        left: doc.scrollingElement
            ? doc.scrollingElement.scrollLeft
            : win.pageXOffset !== undefined
                ? win.pageXOffset
                : doc.documentElement.scrollLeft ||
                    ((doc === null || doc === void 0 ? void 0 : doc.body) && ((_a = dom.parentElement(doc.body)) === null || _a === void 0 ? void 0 : _a.scrollLeft)) ||
                    ((_b = doc === null || doc === void 0 ? void 0 : doc.body) === null || _b === void 0 ? void 0 : _b.scrollLeft) ||
                    0,
        top: doc.scrollingElement
            ? doc.scrollingElement.scrollTop
            : win.pageYOffset !== undefined
                ? win.pageYOffset
                : (doc === null || doc === void 0 ? void 0 : doc.documentElement.scrollTop) ||
                    ((doc === null || doc === void 0 ? void 0 : doc.body) && ((_c = dom.parentElement(doc.body)) === null || _c === void 0 ? void 0 : _c.scrollTop)) ||
                    ((_d = doc === null || doc === void 0 ? void 0 : doc.body) === null || _d === void 0 ? void 0 : _d.scrollTop) ||
                    0,
    };
}
export function getWindowHeight() {
    var globalScope = getGlobalScope();
    return ((globalScope === null || globalScope === void 0 ? void 0 : globalScope.innerHeight) ||
        (document.documentElement && document.documentElement.clientHeight) ||
        (document.body && document.body.clientHeight) ||
        0);
}
export function getWindowWidth() {
    var globalScope = getGlobalScope();
    return ((globalScope === null || globalScope === void 0 ? void 0 : globalScope.innerWidth) ||
        (document.documentElement && document.documentElement.clientWidth) ||
        (document.body && document.body.clientWidth) ||
        0);
}
//# sourceMappingURL=rrweb.js.map